"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Toolkit = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_Toolkit_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.913.03c.729-.118 1.473.114 1.966.624L4.1.84l.163-.187A2.41 2.41 0 0 1 6.288.03C7.39.21 8.2 1.142 8.2 2.233v.091c0 .649-.275 1.267-.762 1.711L4.542 6.67a.657.657 0 0 1-.884 0L.762 4.035A2.317 2.317 0 0 1 0 2.325v-.091C0 1.142.81.21 1.913.03Zm1.27 1.331c-.288-.281-.699-.41-1.102-.344-.61.099-1.056.614-1.056 1.216v.091c0 .372.158.727.437.98L4.1 5.707l2.64-2.403c.278-.253.435-.608.435-.98v-.09c0-.603-.445-1.118-1.057-1.217a1.284 1.284 0 0 0-1.102.344l-.916.895-.917-.895Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.354 8.854a.5.5 0 0 0-.708-.708l-3 3A.5.5 0 0 0 2 12h2.793l-3.147 3.146a.5.5 0 1 0 .708.707l4-4A.5.5 0 0 0 6 11H3.207l2.147-2.146ZM13 1.5a.5.5 0 0 0-1 0V3h-1.5a.5.5 0 1 0 0 1H12v1.5a.5.5 0 1 0 1 0V4h1.5a.5.5 0 0 0 0-1H13V1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.854 8.146A.5.5 0 0 0 9 8.5v6a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .354-.854l-6-6ZM10 14V9.707L14.293 14H10Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_Toolkit_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = Toolkit;
exports["default"] = _default;